import {
  AuditDetailModal,
  ExportLayoutModal,
  FilterSection,
  KpiStrip,
  MovementControlTable,
  ReportHero
} from "./components"
import { useInventoryMovementReport } from "./hooks/useInventoryMovementReport"

/**
 * Inventory Movement / Stock Card Control — dummy data & layout mengikuti HTML referensi.
 */
export default function InventoryMovementReport() {
  const report = useInventoryMovementReport()

  return (
    <section className="w-full px-3 py-4 sm:px-4 md:py-6">
      <div className="flex flex-col gap-4 md:gap-5">
        <ReportHero periodLabel={report.periodLabel} />
        <KpiStrip kpi={report.kpi} />
        <FilterSection
          filter={report.filter}
          setFilter={report.setFilter}
          onSearchReport={report.searchReport}
          onResetFilter={report.resetFilter}
        />
        <MovementControlTable
          rows={report.displayRows}
          sort={report.sort}
          onToggleSort={report.toggleSort}
          onExportXls={() => report.openExportModal("xls")}
          onExportPdf={() => report.openExportModal("pdf")}
          onPrint={() => report.openExportModal("print")}
          onOpenAudit={report.openAudit}
        />

        <ExportLayoutModal
          isOpen={report.exportModalOpen}
          onClose={report.closeExportModal}
          printBlocked={report.printBlocked}
          onChooseOrientation={report.executeExport}
        />

        <AuditDetailModal row={report.auditRow} onClose={report.closeAudit} />
      </div>
    </section>
  )
}
